// src/utils/url.js
export function withOrgQS(url, org) {
  if (!org) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}org=${encodeURIComponent(org)}`;
}
